import Header from '../Navigation/Header'
import Footer from '../Navigation/Footer'
import { Seo } from '../../helpers/Seo'
import { Link } from 'react-router-dom'
import { Icon } from '@iconify/react'
import { ClientsBanner } from '../../components/ClientsBanner'

export default function PersonnalizedLoan() {
    return (
        <div>
            <Seo
                title="Personalized Loan Online | Find The Best Offers | Good Good Finance"
                description="Compare personalized loans on our site to find the ideal option for your financial needs. Access the best offers available and make informed decisions today."
                type="webapp"
                name="Good Good Finance"
            />
            <Header />

            <section className="header">
                <div data-aos="fade-up">
                    <h1 className="header-title">Personalized Loan</h1>

                    <p className="header-subtitle">
                        Get a personalized loan from $100 to $1,500 with Good Good Finance, offering
                        the best terms and conditions! We compare various financing options to find
                        the loan that perfectly fits your needs today. A confidential, free and
                        secure solution!
                    </p>

                    <Link to="/new-lead" className="btn">
                        Apply for a loan
                    </Link>
                </div>
            </section>

            <section className="sect sect-bg-dark">
                <div className="sect-content" data-aos="fade-up">
                    <h2 className="sect-title">Get a Personalized Loan in 4 Easy Steps</h2>

                    <div className="steps" style={{ marginTop: 50 }}>
                        <ol>
                            <li>
                                <h3>Complete Our Online Application Form</h3>
                                <p>
                                    Begin by <Link to="/new-lead">completing our online form</Link>{' '}
                                    with your contact details and the amount you'd like to borrow.
                                    Based on this information, we'll provide you with a real-time
                                    comparison of offers from our partners, including{' '}
                                    <b>interest rates, loan amounts, and estimated timeframes</b>.
                                </p>
                            </li>
                            <li>
                                <h3>Choose a Financing Institution</h3>
                                <p>
                                    By comparing the different offers from our lenders, you can{' '}
                                    <b>select the personalized loan that best fits your needs</b>.
                                    Simply click on the institution of your choice, and you'll be
                                    automatically redirected to their application form to apply for
                                    an instant loan. Once your request is submitted, you'll
                                    typically receive a response within an hour. Be sure to check
                                    their business hours to understand how quickly you can expect a
                                    reply.
                                </p>
                            </li>
                            <li>
                                <h3>How to Apply</h3>
                                <p>
                                    Each lender has its own eligibility criteria. Generally, you'll
                                    need to <b>provide a valid photo ID</b> (such as a health
                                    insurance card, driver's license, or passport). The lender will
                                    then carry out an Instant Bank Verification (IBV loan), which
                                    confirms your ability to repay without the need for a credit
                                    check.
                                </p>
                            </li>
                            <li>
                                <h3>Receive Your Loan Within 24 Hours</h3>
                                <p>
                                    Once you're approved, your payment will be{' '}
                                    <b>transferred within 24 hours of signing the contract</b>. The
                                    funds are sent via e-transfer loan to the address you provide.
                                    Depending on the lender, if you apply in the morning, you may
                                    receive your loan the same day!
                                </p>
                            </li>
                        </ol>
                    </div>
                </div>
            </section>

            <section className="sect sect-bg-light">
                <div className="sect-content" data-aos="fade-up">
                    <h2 className="sect-title">Choose The Amount You need!</h2>

                    <div className="loan-options">
                        <ul>
                            <Link to="/new-lead" className="steps-options">
                                <li>$200 loan</li>
                            </Link>
                            <Link to="/new-lead" className="steps-options">
                                <li>$300 loan</li>
                            </Link>
                            <Link to="/new-lead" className="steps-options">
                                <li>$500 loan</li>
                            </Link>
                            <Link to="/new-lead" className="steps-options">
                                <li>$700 loan</li>
                            </Link>
                            <Link to="/new-lead" className="steps-options">
                                <li>$1,000 loan</li>
                            </Link>
                            <Link to="/new-lead" className="steps-options">
                                <li>$1,500 loan</li>
                            </Link>
                        </ul>
                    </div>
                </div>
            </section>

            <section className="sect sect-bg-dark">
                <div className="sect-content" data-aos="fade-up">
                    <h2 className="sect-title">Get Personalized Credit With Good Good Finance</h2>

                    <p className="sect-subtitle">
                        Life is unpredictable, and financial challenges can arise unexpectedly. To
                        secure a personalized loan quickly, without affecting your credit score,
                        Good Good Finance offers a{' '}
                        <b>comparison of trustworthy and secure online lending institutions</b>. In
                        just a few clicks, discover alternative loan options tailored to your needs
                        and receive funds via e-transfer within 24 hours. Repayment terms vary
                        depending on the lender.
                    </p>

                    <div className="container">
                        <div className="row content">
                            <div className="col-lg-6">
                                <h3>Why Choose Our Products?</h3>
                                <ul className="styled-checklist" style={{ marginTop: 20 }}>
                                    <li>Quick approval process</li>
                                    <li>Secure, free, and no obligation</li>
                                    <li>No credit check required</li>
                                    <li>Available for those with bad credit</li>
                                    <li>Transparent partners with high standards</li>
                                </ul>
                            </div>

                            <div className="col-lg-6 pt-4 pt-lg-0">
                                <h3>Immediate Loans for Every Need</h3>
                                <p>
                                    When facing a challenging situation, Good Good Finance is here
                                    to help by comparing fast, no credit check loans available in
                                    Canada. Best of all, you don’t need to justify your borrowing!
                                    Whatever your circumstances, we provide tailored solutions to
                                    meet your immediate cash needs:
                                </p>
                                <ul className="styled-checklist" style={{ marginTop: 20 }}>
                                    <li>Cash advance</li>
                                    <li>Emergency loan</li>
                                    <li>Personal loan</li>
                                    <li>Payday loan</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="Eligible sect-bg-light">
                <div className="card" data-aos="fade-up">
                    <div className="content">
                        <div className="section-title">
                            <h2>Are You Eligible?</h2>
                        </div>
                        <p>
                            To qualify for a personalized loan from one of our partner institutions,
                            you must:
                        </p>
                        <ul>
                            <li>Be at least 18 years old</li>
                            <li>Be a resident of Canada</li>
                            <li>Have a stable income</li>
                            <li>Have no payment oppositions</li>
                            <li>Have little to now non-sufficient funds (NSF)</li>
                        </ul>
                        <p>
                            You can also qualify for loans if you have bad credit, if you are
                            seeking a loan with no job, or if you need a loan without proof of
                            income or a loan without documents.
                        </p>
                        <Link to="/new-lead" className="btn">
                            Apply for a loan
                        </Link>
                    </div>
                </div>
            </section>

            <ClientsBanner />

            <Footer />
        </div>
    )
}
